
// 时间戳转时间

import moment from 'moment';

export default function(value) {
    return moment(value).format("YYYY-MM-DD HH:mm:ss")
}


// WEBPACK FOOTER //
// ./src/filter/YYYYMMDDhhmmss.js